import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=21195e5e&scoped=true&"
import script from "./QuestionBox.vue?vue&type=script&lang=ts&"
export * from "./QuestionBox.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionBox.vue?vue&type=style&index=0&id=21195e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21195e5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
